package com.eladfinish.bible.contest.lifecycle

import androidx.compose.runtime.Composable
import androidx.compose.runtime.DisposableEffect
import com.eladfinish.bible.contest.di.getKoinInstance
import com.eladfinish.bible.contest.platform.device.KeepScreenOnService

@Composable
fun KeepScreenOn(
    enabled: Boolean,
) {
    val service = getKoinInstance<KeepScreenOnService>()

    DisposableEffect(service, enabled) {
        service.setKeepScreenOn(enabled)

        onDispose {
            service.setKeepScreenOn(false)
        }
    }
}
